module.exports = __webpack_public_path__ + "static/flyer-290c21a159b5d9e8dbbc09009ddb9413.pdf";